<div class="checkin__status__box__wrapper">
  <span class="checkin__status__box__title">
    {{ statusBoxInfo[status].title | translate }}
  </span>
  <span class="checkin__status__box__description" [innerHTML]="statusBoxInfo[status].description | translate:params">
  </span>
</div>
